<script lang="ts">
  import { fade, fly } from 'svelte/transition';
  export let isOpen = false
  export let beforeShow = null
  export let beforeClose = null
  export let showCloseIcon = true
  let openFlag = false
  let closeFlag = false
  export let wrapperStyle = ''
  export let mainStyle = ''
  export let contentStyle = ''
  export let headerStyle = ''
  export let footerStyle = ''
  export let flyDistance = 0
  export let zIndex = 9999999
  const openNext = () => {
    isOpen = true
    openFlag = true
    closeFlag = true
  }
  const closeNext = () => {
    isOpen = false
    openFlag = false
    closeFlag = false
  }
  $: if (isOpen && !openFlag) {
    isOpen = false
    beforeShow ? beforeShow(openNext) : openNext()
  }
  $: if (!isOpen && closeFlag) {
    isOpen = true
    beforeClose ? beforeClose(closeNext) : closeNext()
  }
  export function close() {
    isOpen = false
  }
  export function open() {
    isOpen = true
  }
</script>

<style lang="less" src="./Modal.less">
</style>

{#if isOpen}
  <div class="modal"  style={mainStyle + `;z-index: ${zIndex}`}>
    <div class="backdrop" transition:fade="{{ duration: 500 }}" on:click={close}/> 

    <div 
        class="content-wrapper" 
        style={wrapperStyle} 
        transition:fly="{{ y: flyDistance, duration: 500 }}"
    >
      <slot name="header" style={headerStyle}>
      </slot>

      <div class="content" style={contentStyle}>
        {#if showCloseIcon}
          <span class="close" on:click={close}></span> 
        {/if}
        <slot name="content" {close}/>
      </div>

      <slot name="footer" {close} style={footerStyle}>
      </slot>
    </div>
  </div>
{/if}